import React,{useState,useEffect,useCallback}from'react';
import{useNavigate}from'react-router-dom';
import Layout from'../components/layout/Layout';
import Modal from'../components/common/Modal';
import Badge from'../components/common/Badge';
import StatCard from'../components/common/StatCard';
import api from'../services/api';

const TABS=[['info','Patient Info'],['visits','Visit History'],['problems','Problem List'],['allergies','Allergies'],['vitals','Vitals'],['documents','Documents']];

export default function PatientPage(){
  const nav=useNavigate();
  const [search,setSearch]=useState('');
  const [patients,setPatients]=useState<any[]>([]);
  const [selected,setSelected]=useState<any>(null);
  const [tab,setTab]=useState('info');
  const [visits,setVisits]=useState<any[]>([]);
  const [problems,setProblems]=useState<any[]>([]);
  const [allergies,setAllergies]=useState<any[]>([]);
  const [vitals,setVitals]=useState<any[]>([]);
  const [docs,setDocs]=useState<any[]>([]);
  const [loading,setLoading]=useState(false);
  const [msg,setMsg]=useState('');
  const [showAllergy,setShowAllergy]=useState(false);
  const [showProblem,setShowProblem]=useState(false);
  const [allergyForm,setAllergyForm]=useState({allergenName:'',allergenType:'DRUG',severity:'MODERATE',reaction:''});
  const [problemForm,setProblemForm]=useState({problemName:'',icdCode:'',status:'ACTIVE',notes:''});
  const [stats,setStats]=useState({total:0,today:0,admitted:0,critical:0});
  const notify=(m:string)=>{setMsg(m);setTimeout(()=>setMsg(''),4000);};

  const loadStats=useCallback(async()=>{
    try{
      const r=await api.getPatients?.({take:1}).catch(()=>({data:{total:0}}));
      const today=await api.getTodayPatients?.().catch(()=>({data:{count:0}}));
      setStats({total:r?.data?.total||0,today:today?.data?.count||0,admitted:0,critical:0});
    }catch{}
  },[]);

  // Load latest 40 patients on mount
  useEffect(()=>{
    (async()=>{
      setLoading(true);
      try{
        const r=await api.getPatients?.({take:40,skip:0}).catch(()=>({data:{}}));
        const list=r?.data?.patients||r?.data?.data||r?.data||[];
        setPatients(Array.isArray(list)?list:[]);
      }catch{}
      setLoading(false);
    })();
  },[]);

  const search_=useCallback(async()=>{
    setLoading(true);
    try{
      const r=await api.getPatients?.({search:search.trim()||undefined,take:40}).catch(()=>({data:{}}));
      const list=r?.data?.patients||r?.data?.data||r?.data||[];
      setPatients(Array.isArray(list)?list:[]);
    }catch{}
    setLoading(false);
  },[search]);

  const loadPatient=async(p:any)=>{
    setSelected(p);setTab('info');
    try{
      const [v,pr,al,vt,d]=await Promise.all([
        api.getPatientVisits?.(p.id).catch(()=>({data:[]})),
        api.getPatientProblems?.(p.id).catch(()=>({data:[]})),
        api.getPatientAllergies?.(p.id).catch(()=>({data:[]})),
        api.getVitals?.(p.id).catch(()=>({data:[]})),
        api.getPatientDocuments?.(p.id).catch(()=>({data:[]})),
      ]);
      setVisits(arr(v));setProblem(arr(pr));setAllergies(arr(al));setVitals(arr(vt));setDocs(arr(d));
    }catch{}
  };
  const arr=(r:any)=>Array.isArray(r?.data)?r.data:r?.data?.data||r?.data?.items||r?.data||[];
  const setProbl=(x:any)=>setProblems(x);const setAllrg=(x:any)=>setAllergies(x);const setProblem=(x:any)=>setProblems(x);

  const addAllergy=async()=>{
    if(!selected||!allergyForm.allergenName)return;
    try{await api.addPatientAllergy?.(selected.id,allergyForm);notify('Allergy saved');setShowAllergy(false);
      const r=await api.getPatientAllergies?.(selected.id).catch(()=>({data:[]}));setAllergies(arr(r));}
    catch(e:any){notify('Error: '+(e.response?.data?.message||'failed'));}
  };
  const addProblem=async()=>{
    if(!selected||!problemForm.problemName)return;
    try{await api.addPatientProblem?.(selected.id,problemForm);notify('Problem saved');setShowProblem(false);
      const r=await api.getPatientProblems?.(selected.id).catch(()=>({data:[]}));setProblems(arr(r));}
    catch(e:any){notify('Error: '+(e.response?.data?.message||'failed'));}
  };

  useEffect(()=>{loadStats();},[loadStats]);

  return(
    <Layout>
      <div className="p-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div><h1 className="text-2xl font-bold text-gray-900">Patient Management</h1><p className="text-gray-500">Search and manage patient records</p></div>
          <button onClick={()=>nav('/patients/register')} className="bg-[#02357A] text-white px-4 py-2 rounded-lg hover:bg-[#015CA6] font-medium">+ Register Patient</button>
        </div>
        {msg&&<div className="mb-4 p-3 bg-green-50 border border-green-200 text-green-700 rounded-lg">{msg}</div>}
        <div className="grid grid-cols-4 gap-4 mb-6">
          <StatCard label="Total Patients" value={stats.total} color="blue"/>
          <StatCard label="Today Registered" value={stats.today} color="green"/>
          <StatCard label="Currently Admitted" value={stats.admitted} color="orange"/>
          <StatCard label="Critical" value={stats.critical} color="red"/>
        </div>
        <div className="bg-white rounded-xl shadow-sm border p-4 mb-6">
          <div className="flex gap-3">
            <input value={search} onChange={e=>setSearch(e.target.value)} onKeyDown={e=>e.key==='Enter'&&search_()}
              placeholder="Search by name, UHID, CRM ID, phone, Aadhaar..." className="flex-1 border rounded-lg px-4 py-2 focus:ring-2 focus:ring-[#015CA6] outline-none"/>
            <button onClick={search_} className="bg-[#02357A] text-white px-6 py-2 rounded-lg hover:bg-[#015CA6]">{loading?'Searching...':'Search'}</button>
            <button onClick={()=>nav('/patients/register')} className="border border-[#015CA6] text-[#02357A] px-4 py-2 rounded-lg hover:bg-blue-50">New</button>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-6">
          <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
            <div className="p-4 border-b bg-gray-50"><h3 className="font-semibold text-gray-700">{search.trim()?`Search Results (${patients.length})`:`Latest Patients (${patients.length})`}</h3></div>
            <div className="divide-y overflow-y-auto" style={{maxHeight:'70vh'}}>
              {patients.length===0&&<div className="p-8 text-center text-gray-400">No patients found</div>}
              {patients.map((p:any)=>(
                <div key={p.id} onClick={()=>loadPatient(p)} className={`p-4 cursor-pointer hover:bg-blue-50 transition-colors ${selected?.id===p.id?'bg-blue-50 border-l-4 border-[#015CA6]':''}`}>
                  <div className="flex items-start justify-between">
                    <div><p className="font-semibold text-gray-900">{p.first_name||p.firstName} {p.last_name||p.lastName}</p>
                      <p className="text-sm text-[#02357A] font-mono">{p.uhid}{p.crmId||p.crm_id?` · ${p.crmId||p.crm_id}`:''}</p>
                      <p className="text-xs text-gray-500">{p.gender}, {p.age||p.date_of_birth||'—'} • {p.mobile||p.phone||'—'}</p>
                      <p className="text-xs text-slate-500 mt-0.5">{p.branchName||p.branch_name||'Location not recorded'} · {p.stationName||p.station_name||'Workstation not recorded'}</p></div>
                    <Badge text={p.blood_group||'—'} color="gray"/>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-span-2 bg-white rounded-xl shadow-sm border overflow-hidden">
            {!selected?<div className="flex items-center justify-center h-96 text-gray-400"><div className="text-center"><div className="text-5xl mb-3">👤</div><p>Select a patient to view details</p></div></div>:(
              <>
                <div className="p-4 border-b bg-gradient-to-r from-blue-50 to-indigo-50">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-4">
                      <div className="w-14 h-14 rounded-full bg-blue-200 flex items-center justify-center text-2xl font-bold text-[#02357A]">
                        {(selected.first_name||selected.firstName||'?')[0].toUpperCase()}
                      </div>
                      <div>
                        <h2 className="text-xl font-bold text-gray-900">{selected.first_name||selected.firstName} {selected.last_name||selected.lastName}</h2>
                        <p className="text-[#02357A] font-mono font-semibold">{selected.uhid}{selected.crmId||selected.crm_id?` · ${selected.crmId||selected.crm_id}`:''}</p>
                        <p className="text-sm text-gray-600">{selected.gender} • DOB: {selected.date_of_birth||selected.dateOfBirth||'—'} • Blood: {selected.blood_group||'—'}</p>
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <button onClick={()=>nav(`/patients/edit/${selected.id}`)} className="border px-3 py-1.5 rounded-lg text-sm hover:bg-gray-50">Edit</button>
                      <button onClick={()=>nav(`/appointments/book?patientId=${selected.id}`)} className="bg-green-600 text-white px-3 py-1.5 rounded-lg text-sm hover:bg-green-700">Book Appt</button>
                      <button onClick={()=>nav(`/ipd/admit?patientId=${selected.id}`)} className="bg-[#02357A] text-white px-3 py-1.5 rounded-lg text-sm hover:bg-[#015CA6]">Admit IPD</button>
                    </div>
                  </div>
                  <div className="flex gap-1 mt-4">
                    {TABS.map(([k,l])=><button key={k} onClick={()=>setTab(k)} className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${tab===k?'bg-[#02357A] text-white':'text-gray-600 hover:bg-white hover:text-[#02357A]'}`}>{l}</button>)}
                  </div>
                </div>
                <div className="p-4 overflow-y-auto" style={{maxHeight:'calc(70vh - 160px)'}}>
                  {tab==='info'&&(
                    <div className="grid grid-cols-2 gap-4">
                      {[['Phone',selected.mobile||selected.phone||'—'],['Email',selected.email||'—'],['Address',selected.address||'—'],
                        ['CRM ID',selected.crmId||selected.crm_id||'—'],['ABHA',selected.abhaNumber||selected.abha_number||'—'],
                        ['City',selected.city||'—'],['State',selected.state||'—'],['Pin',selected.pincode||selected.postal_code||'—'],
                        ['Father/Husband',selected.father_name||selected.husband_name||'—'],['Occupation',selected.occupation||'—'],
                        ['Nationality',selected.nationality||'—'],['Religion',selected.religion||'—'],
                        ['Registered location',selected.branchName||selected.branch_name||'Not recorded'],
                        ['Registered workstation',selected.stationName||selected.station_name||'Not recorded']].map(([l,v])=>(
                        <div key={l} className="bg-gray-50 rounded-lg p-3">
                          <p className="text-xs text-gray-500 uppercase tracking-wide">{l}</p>
                          <p className="font-medium text-gray-900 mt-0.5">{v}</p>
                        </div>
                      ))}
                    </div>
                  )}
                  {tab==='visits'&&(
                    <div>
                      <div className="flex justify-between items-center mb-3">
                        <h4 className="font-semibold">Visit History ({visits.length})</h4>
                        <button onClick={()=>nav(`/opd?patientId=${selected.id}`)} className="text-sm bg-[#02357A] text-white px-3 py-1 rounded-lg">New OPD Visit</button>
                      </div>
                      {visits.length===0?<p className="text-center text-gray-400 py-8">No visits yet</p>:
                        <table className="w-full text-sm"><thead className="bg-gray-50"><tr>{['Date','Type','Doctor','Diagnosis','Status'].map(h=><th key={h} className="text-left p-3 text-gray-600 font-medium">{h}</th>)}</tr></thead>
                          <tbody className="divide-y">{visits.map((v:any,i)=><tr key={i} className="hover:bg-gray-50">
                            <td className="p-3">{v.visit_date||v.visitDate||v.created_at?.split('T')[0]||'—'}</td>
                            <td className="p-3"><Badge text={v.visit_type||v.visitType||'OPD'} color="blue"/></td>
                            <td className="p-3">{v.doctor_name||v.doctorName||'—'}</td>
                            <td className="p-3">{v.primary_diagnosis||v.diagnosis||'—'}</td>
                            <td className="p-3"><Badge text={v.status||'COMPLETED'} color="green"/></td>
                          </tr>)}</tbody>
                        </table>}
                    </div>
                  )}
                  {tab==='problems'&&(
                    <div>
                      <div className="flex justify-between mb-3"><h4 className="font-semibold">Problem List ({problems.length})</h4>
                        <button onClick={()=>setShowProblem(true)} className="text-sm bg-orange-600 text-white px-3 py-1 rounded-lg">+ Add Problem</button></div>
                      {problems.length===0?<p className="text-center text-gray-400 py-8">No active problems</p>:
                        <div className="space-y-2">{problems.map((pr:any,i)=>(
                          <div key={i} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border">
                            <div><p className="font-medium">{pr.problem_name||pr.problemName}</p>
                              <p className="text-xs text-gray-500">{pr.icd_code||pr.icdCode||''} • Since: {pr.onset_date||pr.onsetDate||'—'}</p></div>
                            <Badge text={pr.status||'ACTIVE'} color={pr.status==='RESOLVED'?'green':'orange'}/>
                          </div>
                        ))}</div>}
                    </div>
                  )}
                  {tab==='allergies'&&(
                    <div>
                      <div className="flex justify-between mb-3"><h4 className="font-semibold">Allergies ({allergies.length})</h4>
                        <button onClick={()=>setShowAllergy(true)} className="text-sm bg-red-600 text-white px-3 py-1 rounded-lg">+ Add Allergy</button></div>
                      {allergies.length===0?<p className="text-center text-gray-400 py-8">No allergies recorded</p>:
                        <div className="space-y-2">{allergies.map((a:any,i)=>(
                          <div key={i} className="flex items-center justify-between p-3 bg-red-50 rounded-lg border border-red-200">
                            <div><p className="font-semibold text-red-700">{a.allergen_name||a.allergenName}</p>
                              <p className="text-sm text-gray-600">{a.allergen_type||a.allergenType} • Reaction: {a.reaction||'—'}</p></div>
                            <Badge text={a.severity||'UNKNOWN'} color={a.severity==='SEVERE'?'red':a.severity==='MODERATE'?'orange':'yellow'}/>
                          </div>
                        ))}</div>}
                    </div>
                  )}
                  {tab==='vitals'&&(
                    <div>
                      <h4 className="font-semibold mb-3">Recent Vitals ({vitals.length})</h4>
                      {vitals.length===0?<p className="text-center text-gray-400 py-8">No vitals recorded</p>:
                        <table className="w-full text-sm"><thead className="bg-gray-50"><tr>{['Date/Time','BP','Pulse','Temp','SpO2','Weight','RR'].map(h=><th key={h} className="text-left p-2 text-gray-600 font-medium">{h}</th>)}</tr></thead>
                          <tbody className="divide-y">{vitals.slice(0,15).map((v:any,i)=><tr key={i} className="hover:bg-gray-50">
                            <td className="p-2 text-xs">{v.recorded_at?.replace('T',' ').substring(0,16)||v.createdAt?.substring(0,16)||'—'}</td>
                            <td className="p-2">{v.systolic&&v.diastolic?`${v.systolic}/${v.diastolic}`:v.blood_pressure||'—'}</td>
                            <td className="p-2">{v.pulse||v.heart_rate||'—'}</td>
                            <td className="p-2">{v.temperature||'—'}{v.temperature?'°F':''}</td>
                            <td className="p-2">{v.spo2||v.oxygen_saturation||'—'}{v.spo2?'%':''}</td>
                            <td className="p-2">{v.weight||'—'}{v.weight?'kg':''}</td>
                            <td className="p-2">{v.respiratory_rate||v.rr||'—'}</td>
                          </tr>)}</tbody>
                        </table>}
                    </div>
                  )}
                  {tab==='documents'&&(
                    <div>
                      <h4 className="font-semibold mb-3">Documents ({docs.length})</h4>
                      {docs.length===0?<p className="text-center text-gray-400 py-8">No documents uploaded</p>:
                        <div className="grid grid-cols-2 gap-3">{docs.map((d:any,i)=>(
                          <div key={i} className="p-3 border rounded-lg hover:shadow-sm">
                            <p className="font-medium text-sm">{d.original_name||d.document_name||d.name||'Document'}</p>
                            <p className="text-xs text-gray-500">{d.document_type||d.type||'—'} • {d.created_at?.split('T')[0]||'—'}</p>
                          </div>
                        ))}</div>}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
        <Modal isOpen={showAllergy} onClose={()=>setShowAllergy(false)} title="Add Allergy">
          <div className="space-y-4">
            <div><label className="block text-sm font-medium mb-1">Allergen Name *</label><input value={allergyForm.allergenName} onChange={e=>setAllergyForm(f=>({...f,allergenName:e.target.value}))} className="w-full border rounded-lg p-2"/></div>
            <div><label className="block text-sm font-medium mb-1">Type</label><select value={allergyForm.allergenType} onChange={e=>setAllergyForm(f=>({...f,allergenType:e.target.value}))} className="w-full border rounded-lg p-2">{['DRUG','FOOD','ENVIRONMENT','LATEX','CONTRAST','OTHER'].map(o=><option key={o}>{o}</option>)}</select></div>
            <div><label className="block text-sm font-medium mb-1">Severity</label><select value={allergyForm.severity} onChange={e=>setAllergyForm(f=>({...f,severity:e.target.value}))} className="w-full border rounded-lg p-2">{['MILD','MODERATE','SEVERE','LIFE_THREATENING'].map(o=><option key={o}>{o}</option>)}</select></div>
            <div><label className="block text-sm font-medium mb-1">Reaction</label><textarea value={allergyForm.reaction} onChange={e=>setAllergyForm(f=>({...f,reaction:e.target.value}))} className="w-full border rounded-lg p-2" rows={2}/></div>
            <div className="flex gap-2 justify-end"><button onClick={()=>setShowAllergy(false)} className="px-4 py-2 border rounded-lg">Cancel</button><button onClick={addAllergy} className="px-4 py-2 bg-red-600 text-white rounded-lg">Save Allergy</button></div>
          </div>
        </Modal>
        <Modal isOpen={showProblem} onClose={()=>setShowProblem(false)} title="Add Problem">
          <div className="space-y-4">
            <div><label className="block text-sm font-medium mb-1">Problem Name *</label><input value={problemForm.problemName} onChange={e=>setProblemForm(f=>({...f,problemName:e.target.value}))} className="w-full border rounded-lg p-2" placeholder="e.g. Hypertension"/></div>
            <div><label className="block text-sm font-medium mb-1">ICD-10 Code</label><input value={problemForm.icdCode} onChange={e=>setProblemForm(f=>({...f,icdCode:e.target.value}))} className="w-full border rounded-lg p-2" placeholder="e.g. I10"/></div>
            <div><label className="block text-sm font-medium mb-1">Status</label><select value={problemForm.status} onChange={e=>setProblemForm(f=>({...f,status:e.target.value}))} className="w-full border rounded-lg p-2">{['ACTIVE','RESOLVED','CHRONIC','RECURRENT'].map(o=><option key={o}>{o}</option>)}</select></div>
            <div><label className="block text-sm font-medium mb-1">Notes</label><textarea value={problemForm.notes} onChange={e=>setProblemForm(f=>({...f,notes:e.target.value}))} className="w-full border rounded-lg p-2" rows={2}/></div>
            <div className="flex gap-2 justify-end"><button onClick={()=>setShowProblem(false)} className="px-4 py-2 border rounded-lg">Cancel</button><button onClick={addProblem} className="px-4 py-2 bg-[#02357A] text-white rounded-lg">Save Problem</button></div>
          </div>
        </Modal>
      </div>
    </Layout>
  );
}
